<template>
<div class="page">
    <div class="top">
        <img src="@/assets/user/login_bg.png" alt="">
    </div>
    <form class="dataFrom">        
        <div class="vant-input">
            <keep-alive>
                <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch"  @select="handleSelect" placeholder="请输入你的设备编码"></se-autocomplete>
            </keep-alive>
        </div>
        <div class="formLine">
            <mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询</mt-button> 
        </div>       
    </form>
</div>
</template>
<script>
import SeAutocomplete from '@/components/SeAutocomplete'
export default{
    components:{
        SeAutocomplete 
    },
    data(){
        return{
            iccid:''
        }
    },
    method:{
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');         
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;      
            cb(results);      
        },
        handleSelect(item){
            this.iccid = item 
        },  
        userQuerySIM(){}
    }
}
</script>
<style scoped lang="less">
.page{
    height: 100%;
    width: 100%;
    background: #f4f5f9;
    .top{
        padding-top: 10px;
        text-align: center;
        img{
            width: 90%;
        }
    }
    .dataFrom{
		width:90%;
		margin:0 auto;
		border-radius:10px;
		text-align: center;
		padding:20px 0 ;
		button{
			width:100%;
			line-height:34px;
			font-size: 14px;
			height:34px;
			background:#007aff;
			border:0px solid #282E3E;
			margin:0 auto;
		}
	}
	.vant-input{
		/deep/ input[type=text]{
			background: #fff;
			border:1px solid #d9d9d9;
			color: #999;
			text-align: center;
			width:100%;
			height:40px;
			margin:0 auto;
			margin-bottom:14px;
		}
	}
}
</style>